import { getAnalytics } from "firebase/analytics";
import app from "./firebase"; // MUST come from your existing firebase.js

let analytics = null;

if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

export { analytics };